import React, { useContext } from "react";
import Notification from "../../../../components/Notification";
import { DangerIcon } from "../../../../components/Icons";
import i18next from "i18next";
import { DeliveryContext } from "../../../../models/DeliveryContext";
import { useProductStock } from "../../../../Api/ingredientsApi";

const OutOfStockNotification = () => {
    const { storeId } = useContext(DeliveryContext);
    const { isLoading } = useProductStock(storeId);

    if (!storeId || isLoading) {
        return null;
    }

    return (
        <Notification
            style={{
                marginBottom: "20px",
                display: "flex",
                alignItems: "center",
            }}
            type="danger"
            icon={<DangerIcon />}
        >
            {i18next.t("productDetails.outOfStock")}
        </Notification>
    );
};

export default OutOfStockNotification;
